//Menu Campanas
import Gire_Img from '../../../Images/gallery/menu/gire_grid.png';
import GireHover_Img from '../../../Images/gallery/menu/gire_grid-hover.png';
import Torres_Img from '../../../Images/gallery/menu/torres_grid.png';
import TorresHover_Img from '../../../Images/gallery/menu/torres_grid-hover.png';
import Charly_Img from '../../../Images/gallery/menu/charly_grid.png';
import CharlyHover_Img from '../../../Images/gallery/menu/charly_grid-hover.png';
import Lanzamiento_Img from '../../../Images/gallery/menu/lanzamiento_grid.png';
import LanzamientoHover_Img from '../../../Images/gallery/menu/lanzamiento_grid-hover.png';
import Grande_Img from '../../../Images/gallery/menu/grande_grid.png';
import GrandeHover_Img from '../../../Images/gallery/menu/grande_grid-hover.png';
import Puma_Img from '../../../Images/gallery/menu/puma_grid.png';
import PumaHover_Img from '../../../Images/gallery/menu/puma_grid-hover.png';
import Savile_Img from '../../../Images/gallery/menu/savile_grid.png';
import SavileHover_Img from '../../../Images/gallery/menu/savile_grid-hover.png';
import Empresario_Img from '../../../Images/gallery/menu/empresario_grid.png';
import EmpresarioHover_Img from '../../../Images/gallery/menu/empresario_grid-hover.png';
import Interceramic_Img from '../../../Images/gallery/menu/interceramic_grid.png';
import InterceramicHover_Img from '../../../Images/gallery/menu/interceramic_grid-hover.png';
import Idealz_Img from '../../../Images/gallery/menu/idealz_grid.png';
import IdealzHover_Img from '../../../Images/gallery/menu/idealz_grid-hover.png';

//Menu Spots
import Knockout_Img from '../../../Images/gallery/menu-spots/knockout_grid.png';
import KnockoutHover_Img from '../../../Images/gallery/menu-spots/knockout_grid-hover.png';
import Lux_Img from '../../../Images/gallery/menu-spots/lux_grid.png';
import LuxHover_Img from '../../../Images/gallery/menu-spots/lux_grid-hover.png';
import Bectris_Img from '../../../Images/gallery/menu-spots/bectris_grid.png';
import BectrisHover_Img from '../../../Images/gallery/menu-spots/bectris_grid-hover.png';
import Bectris2_Img from '../../../Images/gallery/menu-spots/bectris2_grid.png';
import Bectris2Hover_Img from '../../../Images/gallery/menu-spots/bectris2_grid-hover.png';
import Chivas_Img from '../../../Images/gallery/menu-spots/chivas_grid.png';
import ChivasHover_Img from '../../../Images/gallery/menu-spots/chivas_grid-hover.png';
import Cineminuto_Img from '../../../Images/gallery/menu-spots/cineminuto_grid.png';
import CineminutoHover_Img from '../../../Images/gallery/menu-spots/cineminuto_grid-hover.png';
import Coca_Img from '../../../Images/gallery/menu-spots/coca_grid.png';
import CocaHover_Img from '../../../Images/gallery/menu-spots/coca_grid-hover.png';
import Excelsior_Img from '../../../Images/gallery/menu-spots/excelsior_grid.png';
import ExcelsiorHover_Img from '../../../Images/gallery/menu-spots/excelsior_grid-hover.png';
import Gallos_Img from '../../../Images/gallery/menu-spots/gallos_grid.png';
import GallosHover_Img from '../../../Images/gallery/menu-spots/gallos_grid-hover.png';
import InterceramicSpot_Img from '../../../Images/gallery/menu-spots/interceramic_grid.png';
import InterceramicSpotHover_Img from '../../../Images/gallery/menu-spots/interceramic_grid-hover.png';
import Interceramic2_Img from '../../../Images/gallery/menu-spots/interceramic2_grid.png';
import Interceramic2Hover_Img from '../../../Images/gallery/menu-spots/interceramic2_grid-hover.png';
import Lg_Img from '../../../Images/gallery/menu-spots/lg_grid.png';
import LgHover_Img from '../../../Images/gallery/menu-spots/lg_grid-hover.png';
import Mapaton_Img from '../../../Images/gallery/menu-spots/mapaton_grid.png';
import MapatonHover_Img from '../../../Images/gallery/menu-spots/mapaton_grid-hover.png';
import Opticas_Img from '../../../Images/gallery/menu-spots/opticas_grid.png';
import OpticasHover_Img from '../../../Images/gallery/menu-spots/opticas_grid-hover.png';
import Rayados_Img from '../../../Images/gallery/menu-spots/rayados_grid.png';
import RadosHover_Img from '../../../Images/gallery/menu-spots/rayados_grid-hover.png';
import Rmx_Img from '../../../Images/gallery/menu-spots/rmx_grid.png';
import RmxHover_Img from '../../../Images/gallery/menu-spots/rmx_grid-hover.png';
import IMMMU_Img from '../../../Images/gallery/menu-spots/immmu_grid.png';
import IMMMUHover_Img from '../../../Images/gallery/menu-spots/immmu_grid-hover.png';
import betVIP_Img from '../../../Images/gallery/menu-spots/betvip_grid.png';
import betVIPHover_Img from '../../../Images/gallery/menu-spots/betvip_grid-hover.png';
//Menu Corporativo
import InterceramicCorp_Img from '../../../Images/gallery/menu-corporativo/interceramic_grid.png';
import InterceramicCorpHover_Img from '../../../Images/gallery/menu-corporativo/interceramic_grid-hover.png';
import Aereolineas_Img from '../../../Images/gallery/menu-corporativo/aereolinea_grid.png';
import AereolineasHover_Img from '../../../Images/gallery/menu-corporativo/aereolinea_grid-hover.png';
import Galiper_Img from '../../../Images/gallery/menu-corporativo/galiper_grid.png';
import GaliperHover_Img from '../../../Images/gallery/menu-corporativo/galiper_grid-hover.png';

//Menu Post-Producción
import Post_Item_1 from '../../../Images/gallery/menu-post/reel_grid.png';
import Post_Item_1_Hover from '../../../Images/gallery/menu-post/reel_grid-hover.png';
import Post_Item_2 from '../../../Images/gallery/menu-post/betcris_grid.png';
import Post_Item_2_Hover from '../../../Images/gallery/menu-post/betcris_grid-hover.png';
import Post_Item_3 from '../../../Images/gallery/menu-post/charly_grid.png';
import Post_Item_3_Hover from '../../../Images/gallery/menu-post/charly_grid-hover.png';
import Post_Item_4 from '../../../Images/gallery/menu-post/imagen_grid.png';
import Post_Item_4_Hover from '../../../Images/gallery/menu-post/imagen_grid-hover.png';
import Post_Item_5 from '../../../Images/gallery/menu-post/teleton_grid.png';
import Post_Item_5_Hover from '../../../Images/gallery/menu-post/teleton_grid-hover.png';
import Post_Item_6 from '../../../Images/gallery/menu-post/interceramic_grid.png';
import Post_Item_6_Hover from '../../../Images/gallery/menu-post/interceramic_grid-hover.png';
import Post_Item_7 from '../../../Images/gallery/menu-post/lg_grid.png';
import Post_Item_7_Hover from '../../../Images/gallery/menu-post/lg_grid-hover.png';
import Post_Item_8 from '../../../Images/gallery/menu-post/warner_grid.png';
import Post_Item_8_Hover from '../../../Images/gallery/menu-post/warner_grid-hover.png';

//Menu Videoclips
import Video_Item_1 from '../../../Images/gallery/menu-videoclips/lila_grid.png';
import Video_Item_1_Hover from '../../../Images/gallery/menu-videoclips/lila_grid-hover.png';
import Video_Item_2 from '../../../Images/gallery/menu-videoclips/thalia_grid.png';
import Video_Item_2_Hover from '../../../Images/gallery/menu-videoclips/thalia_grid-hover.png';
import Video_Item_3 from '../../../Images/gallery/menu-videoclips/ana_grid.png';
import Video_Item_3_Hover from '../../../Images/gallery/menu-videoclips/ana_grid-hover.png';
import Video_Item_4 from '../../../Images/gallery/menu-videoclips/alessandra_grid.png';
import Video_Item_4_Hover from '../../../Images/gallery/menu-videoclips/alessandra_grid-hover.png';
import Video_Item_5 from '../../../Images/gallery/menu-videoclips/beto_grid.png';
import Video_Item_5_Hover from '../../../Images/gallery/menu-videoclips/beto_grid-hover.png';
import Video_Item_6 from '../../../Images/gallery/menu-videoclips/centro_grid.png';
import Video_Item_6_Hover from '../../../Images/gallery/menu-videoclips/centro_grid-hover.png';

//Menu Social
import Social_Item_1 from '../../../Images/gallery/menu-social/gire_grid.png';
import Social_Item_1_Hover from '../../../Images/gallery/menu-social/gire_grid-hover.png';
import Social_Item_2 from '../../../Images/gallery/menu-social/teleton_grid.png';
import Social_Item_2_Hover from '../../../Images/gallery/menu-social/teleton_grid-hover.png';
import Social_Item_3 from '../../../Images/gallery/menu-social/antes_grid.png';
import Social_Item_3_Hover from '../../../Images/gallery/menu-social/antes_grid-hover.png';
import Social_Item_4 from '../../../Images/gallery/menu-social/implanon_grid.png';
import Social_Item_4_Hover from '../../../Images/gallery/menu-social/implanon_grid-hover.png';

//Menu Fashion
import Fashion_Item_1 from '../../../Images/gallery/menu-fashion/grid_img1.png';
import Fashion_Item_1_Hover from '../../../Images/gallery/menu-fashion/grid_img1-hover.png';
import Fashion_Item_2 from '../../../Images/gallery/menu-fashion/grid_img2.png';
import Fashion_Item_2_Hover from '../../../Images/gallery/menu-fashion/grid_img2-hover.png';
import Fashion_Item_3 from '../../../Images/gallery/menu-fashion/grid_img3.png';
import Fashion_Item_3_Hover from '../../../Images/gallery/menu-fashion/grid_img3-hover.png';
import Fashion_Item_4 from '../../../Images/gallery/menu-fashion/grid_img4.png';
import Fashion_Item_4_Hover from '../../../Images/gallery/menu-fashion/grid_img4-hover.png';
import Fashion_Item_5 from '../../../Images/gallery/menu-fashion/grid_img5.png';
import Fashion_Item_5_Hover from '../../../Images/gallery/menu-fashion/grid_img5-hover.png';
import Fashion_Item_6 from '../../../Images/gallery/menu-fashion/grid_img6.png';
import Fashion_Item_6_Hover from '../../../Images/gallery/menu-fashion/grid_img6-hover.png';

//Menu Retrato
import Retrato_Item_1 from '../../../Images/gallery/menu-retrato/grid_img1.png';
import Retrato_Item_1_Hover from '../../../Images/gallery/menu-retrato/grid_img1-hover.png';
import Retrato_Item_2 from '../../../Images/gallery/menu-retrato/grid_img2.png';
import Retrato_Item_2_Hover from '../../../Images/gallery/menu-retrato/grid_img2-hover.png';

//Menu Deporte
import Sport_Item_1 from '../../../Images/gallery/menu-deporte/grid_img1.png';
import Sport_Item_1_Hover from '../../../Images/gallery/menu-deporte/grid_img1-hover.png';
import Sport_Item_2 from '../../../Images/gallery/menu-deporte/grid_img2.png';
import Sport_Item_2_Hover from '../../../Images/gallery/menu-deporte/grid_img2-hover.png';
import Sport_Item_3 from '../../../Images/gallery/menu-deporte/grid_img3.png';
import Sport_Item_3_Hover from '../../../Images/gallery/menu-deporte/grid_img3-hover.png';
import Sport_Item_4 from '../../../Images/gallery/menu-deporte/grid_img4.png';
import Sport_Item_4_Hover from '../../../Images/gallery/menu-deporte/grid_img4-hover.png';
import Sport_Item_5 from '../../../Images/gallery/menu-deporte/grid_img5.png';
import Sport_Item_5_Hover from '../../../Images/gallery/menu-deporte/grid_img5-hover.png';

//Menu Bebidas
import Drinks_Item_1 from '../../../Images/gallery/menu-bebidas/grid_img1.png';
import Drinks_Item_1_Hover from '../../../Images/gallery/menu-bebidas/grid_img1-hover.png';
import Drinks_Item_2 from '../../../Images/gallery/menu-bebidas/grid_img2.png';
import Drinks_Item_2_Hover from '../../../Images/gallery/menu-bebidas/grid_img2-hover.png';
import Drinks_Item_3 from '../../../Images/gallery/menu-bebidas/grid_img3.png';
import Drinks_Item_3_Hover from '../../../Images/gallery/menu-bebidas/grid_img3-hover.png';
import Drinks_Item_4 from '../../../Images/gallery/menu-bebidas/grid_img4.png';
import Drinks_Item_4_Hover from '../../../Images/gallery/menu-bebidas/grid_img4-hover.png';
import Drinks_Item_5 from '../../../Images/gallery/menu-bebidas/grid_img5.png';
import Drinks_Item_5_Hover from '../../../Images/gallery/menu-bebidas/grid_img5-hover.png';
import Drinks_Item_6 from '../../../Images/gallery/menu-bebidas/grid_img6.png';
import Drinks_Item_6_Hover from '../../../Images/gallery/menu-bebidas/grid_img6-hover.png';
import Drinks_Item_7 from '../../../Images/gallery/menu-bebidas/grid_img7.png';
import Drinks_Item_7_Hover from '../../../Images/gallery/menu-bebidas/grid_img7-hover.png';
import Drinks_Item_8 from '../../../Images/gallery/menu-bebidas/grid_img8.png';
import Drinks_Item_8_Hover from '../../../Images/gallery/menu-bebidas/grid_img8-hover.png';
import Drinks_Item_9 from '../../../Images/gallery/menu-bebidas/grid_img9.png';
import Drinks_Item_9_Hover from '../../../Images/gallery/menu-bebidas/grid_img9-hover.png';

//Menu Cultural
import Cultural_Item_1 from '../../../Images/gallery/menu-cultural/grid_img1.png';
import Cultural_Item_1_Hover from '../../../Images/gallery/menu-cultural/grid_img1-hover.png';

//Menu Camapanas
import Campanas_Item_1 from '../../../Images/gallery/menu-campanas/grid_img1.png';
import Campanas_Item_1_Hover from '../../../Images/gallery/menu-campanas/grid_img1-hover.png';
import Campanas_Item_2 from '../../../Images/gallery/menu-campanas/grid_img2.png';
import Campanas_Item_2_Hover from '../../../Images/gallery/menu-campanas/grid_img2-hover.png';
import Campanas_Item_3 from '../../../Images/gallery/menu-campanas/grid_img3.png';
import Campanas_Item_3_Hover from '../../../Images/gallery/menu-campanas/grid_img3-hover.png';

export const BTN_CONTACT = [
  {
    text: 'CONTACT',
  },
];

export const BTN_LINKS = [
  {
    link: '/es',
    text: 'ESP',
  },
  {
    link: '/en',
    text: 'ENG',
  },
];

export const NAV_FILMS = [
  {
    label: 'Reel',
    modal: 'reel-films',
  },
  {
    label: 'ABOUT',
    modal: 'about',
  },
  {
    label: 'PORTFOLIO',
    modal: 'portfolio-films',
  },
  {
    label: 'PRODUCTION SERVICES',
    modal: 'films-services',
  },
];

export const NAV_STUDIO = [
  {
    label: 'Reel',
    modal: 'reel-studio',
  },
  {
    label: 'PORTFOLIO',
    subMenu: 'portfolio',
  },
  {
    label: 'PHOTOGRAPHY',
    subMenu: 'photo',
  },
  {
    label: 'PRODUCTION SERVICES',
    modal: 'production-services',
  },
  {
    label: 'AI SERVICES',
    modal: 'ai-services',
  },
  {
    label: 'DIRECTORS',
    modal: 'directors',
  },
  {
    label: 'PHOTOGRAPHERS',
    modal: 'photographers',
  },
  {
    label: 'CLIENTS',
    modal: 'clients',
  },
];

export const TIT_PORTFOLIO = [
  {
    label: 'PORTFOLIO',
  },
];

export const SUB_PORTAFOLIO = [
  {
    label: 'CAMPAIGNS',
    subMenu: 'campanas',
  },
  {
    label: 'Spots',
    subMenu: 'spots',
  },
  {
    label: 'CORPORATIVE',
    subMenu: 'corporativo',
  },
  {
    label: 'POSTPRODUCTION',
    subMenu: 'postProduction',
  },
  {
    label: 'Videoclips',
    subMenu: 'videoclips',
  },
  {
    label: 'Social',
    subMenu: 'social',
  },
];

export const TIT_PHOTO = [
  {
    label: 'PHOTOGRAPHY',
  },
];

export const SUB_PHOTO = [
  {
    label: 'FASHION',
    subMenu: 'fashion',
  },
  {
    label: 'PORTRAIT',
    subMenu: 'retrato',
  },
  {
    label: 'SPORT',
    subMenu: 'sports',
  },
  {
    label: 'Beverages',
    subMenu: 'drinks',
  },
  {
    label: 'CULTURAL',
    subMenu: 'cultural',
  },
  {
    label: 'CAMPAIGNS',
    subMenu: 'photoCampanas',
  },
];

export const TIT_CAMPAINGS = [
  {
    label: 'CAMPAIGNS',
  },
];

export const CAMPAINGS_ITEMS = [
  {
    bgImage: Gire_Img,
    bgImageHov: GireHover_Img,
    modal: 'campaign-gire',
  },
  {
    bgImage: Torres_Img,
    bgImageHov: TorresHover_Img,
    modal: 'campaign-torres',
  },
  {
    bgImage: Charly_Img,
    bgImageHov: CharlyHover_Img,
    modal: 'campaign-charly',
  },
  {
    bgImage: Lanzamiento_Img,
    bgImageHov: LanzamientoHover_Img,
    modal: 'campaign-betvip',
  },
  {
    bgImage: Grande_Img,
    bgImageHov: GrandeHover_Img,
    modal: 'campaign-betvip-2',
  },
  {
    bgImage: Puma_Img,
    bgImageHov: PumaHover_Img,
    modal: 'campaign-puma',
  },
  {
    bgImage: Savile_Img,
    bgImageHov: SavileHover_Img,
    modal: 'campaign-savile',
  },
  {
    bgImage: Empresario_Img,
    bgImageHov: EmpresarioHover_Img,
    modal: 'campaign-unifin',
  },
  {
    bgImage: Interceramic_Img,
    bgImageHov: InterceramicHover_Img,
    modal: 'campaign-interceramic',
  },
  {
    bgImage: Idealz_Img,
    bgImageHov: IdealzHover_Img,
    modal: 'campaign-idealz',
  },
];

export const TIT_SPOTS = [
  {
    label: 'Spots',
  },
];

export const SPOT_ITEMS = [
  {
    bgImage: IMMMU_Img,
    bgImageHov: IMMMUHover_Img,
    modal: 'spot-immmu',
  },
  {
    bgImage: betVIP_Img,
    bgImageHov: betVIPHover_Img,
    modal: 'spot-betvip',
  },
  {
    bgImage: Knockout_Img,
    bgImageHov: KnockoutHover_Img,
    modal: 'spot-knockout',
  },
  {
    bgImage: Lux_Img,
    bgImageHov: LuxHover_Img,
    modal: 'spot-lux',
  },
  {
    bgImage: Rayados_Img,
    bgImageHov: RadosHover_Img,
    modal: 'spot-rayados',
  },
  {
    bgImage: Chivas_Img,
    bgImageHov: ChivasHover_Img,
    modal: 'spot-chivas',
  },
  {
    bgImage: Gallos_Img,
    bgImageHov: GallosHover_Img,
    modal: 'spot-gallos',
  },
  {
    bgImage: InterceramicSpot_Img,
    bgImageHov: InterceramicSpotHover_Img,
    modal: 'spot-interceramic',
  },
  {
    bgImage: Bectris_Img,
    bgImageHov: BectrisHover_Img,
    modal: 'spot-betcris',
  },
  {
    bgImage: Coca_Img,
    bgImageHov: CocaHover_Img,
    modal: 'spot-coca',
  },
  {
    bgImage: Cineminuto_Img,
    bgImageHov: CineminutoHover_Img,
    modal: 'spot-cineminuto',
  },
  {
    bgImage: Opticas_Img,
    bgImageHov: OpticasHover_Img,
    modal: 'spot-opticas',
  },
  {
    bgImage: Lg_Img,
    bgImageHov: LgHover_Img,
    modal: 'spot-lg',
  },
  {
    bgImage: Excelsior_Img,
    bgImageHov: ExcelsiorHover_Img,
    modal: 'spot-excelsior',
  },
  {
    bgImage: Rmx_Img,
    bgImageHov: RmxHover_Img,
    modal: 'spot-rmx',
  },
  {
    bgImage: Mapaton_Img,
    bgImageHov: MapatonHover_Img,
    modal: 'spot-mapaton',
  },
  {
    bgImage: Bectris2_Img,
    bgImageHov: Bectris2Hover_Img,
    modal: 'spot-betcris2',
  },
  {
    bgImage: Interceramic2_Img,
    bgImageHov: Interceramic2Hover_Img,
    modal: 'spot-interceramic2',
  },
];

export const TIT_CORP = [
  {
    label: 'CORPORATIVE',
  },
];

export const CORP_ITEMS = [
  {
    bgImage: InterceramicCorp_Img,
    bgImageHov: InterceramicCorpHover_Img,
    modal: 'corporate-interceramic',
  },
  {
    bgImage: Aereolineas_Img,
    bgImageHov: AereolineasHover_Img,
    modal: 'corporate-aerolineas',
  },
  {
    bgImage: Galiper_Img,
    bgImageHov: GaliperHover_Img,
    modal: 'corporate-galiper',
  },
];

export const TIT_POST = [
  {
    label: 'POSTPRODUCTION',
  },
];

export const POST_ITEMS = [
  {
    bgImage: Post_Item_1,
    bgImageHov: Post_Item_1_Hover,
    modal: 'reel-post',
  },
  {
    bgImage: Post_Item_2,
    bgImageHov: Post_Item_2_Hover,
    modal: 'betcris-post',
  },
  {
    bgImage: Post_Item_3,
    bgImageHov: Post_Item_3_Hover,
    modal: 'charly-post',
  },
  {
    bgImage: Post_Item_4,
    bgImageHov: Post_Item_4_Hover,
    modal: 'imagen-post',
  },
  {
    bgImage: Post_Item_5,
    bgImageHov: Post_Item_5_Hover,
    modal: 'teleton-post',
  },
  {
    bgImage: Post_Item_6,
    bgImageHov: Post_Item_6_Hover,
    modal: 'interceramic-post',
  },
  {
    bgImage: Post_Item_7,
    bgImageHov: Post_Item_7_Hover,
    modal: 'lg-post',
  },
  {
    bgImage: Post_Item_8,
    bgImageHov: Post_Item_8_Hover,
    modal: 'warner-post',
  },
];

export const TIT_VIDEOCLIPS = [
  {
    label: 'VIDEOCLIPS',
  },
];

export const VIDEOCLIPS_ITEMS = [
  {
    bgImage: Video_Item_1,
    bgImageHov: Video_Item_1_Hover,
    modal: 'lila-videoclips',
  },
  {
    bgImage: Video_Item_2,
    bgImageHov: Video_Item_2_Hover,
    modal: 'thalia-videoclips',
  },
  {
    bgImage: Video_Item_3,
    bgImageHov: Video_Item_3_Hover,
    modal: 'ana-videoclips',
  },
  {
    bgImage: Video_Item_4,
    bgImageHov: Video_Item_4_Hover,
    modal: 'alessandra-videoclips',
  },
  {
    bgImage: Video_Item_5,
    bgImageHov: Video_Item_5_Hover,
    modal: 'beto-videoclips',
  },
  {
    bgImage: Video_Item_6,
    bgImageHov: Video_Item_6_Hover,
    modal: 'centro-videoclips',
  },
];

export const TIT_SOCIAL = [
  {
    label: 'SOCIAL',
  },
];

export const SOCIAL_ITEMS = [
  {
    bgImage: Social_Item_1,
    bgImageHov: Social_Item_1_Hover,
    modal: 'gire-social',
  },
  {
    bgImage: Social_Item_2,
    bgImageHov: Social_Item_2_Hover,
    modal: 'teleton-social',
  },
  {
    bgImage: Social_Item_3,
    bgImageHov: Social_Item_3_Hover,
    modal: 'antes-social',
  },
  {
    bgImage: Social_Item_4,
    bgImageHov: Social_Item_4_Hover,
    modal: 'implanon-social',
  },
];

export const TIT_FASHION = [
  {
    label: 'FASHION',
  },
];

export const FASHION_ITEMS = [
  {
    bgImage: Fashion_Item_1,
    bgImageHov: Fashion_Item_1_Hover,
    modal: 'fashion-knockout',
  },
  {
    bgImage: Fashion_Item_2,
    bgImageHov: Fashion_Item_2_Hover,
    modal: 'fashion-vassarette',
  },
  {
    bgImage: Fashion_Item_3,
    bgImageHov: Fashion_Item_3_Hover,
    modal: 'fashion-fruit-1',
  },
  {
    bgImage: Fashion_Item_4,
    bgImageHov: Fashion_Item_4_Hover,
    modal: 'fashion-fruit-2',
  },
  {
    bgImage: Fashion_Item_5,
    bgImageHov: Fashion_Item_5_Hover,
    modal: 'fashion-curvation',
  },
  {
    bgImage: Fashion_Item_6,
    bgImageHov: Fashion_Item_6_Hover,
    modal: 'fashion-vassarete-2',
  },
];

export const TIT_RETRATO = [
  {
    label: 'PORTRAIT',
  },
];

export const RETRATO_ITEMS = [
  {
    bgImage: Retrato_Item_1,
    bgImageHov: Retrato_Item_1_Hover,
    modal: 'retrato-ficj',
  },
  {
    bgImage: Retrato_Item_2,
    bgImageHov: Retrato_Item_2_Hover,
    modal: 'retrato-gire',
  },
];

export const TIT_SPORTS = [
  {
    label: 'SPORT',
  },
];

export const SPORTS_ITEMS = [
  {
    bgImage: Sport_Item_1,
    bgImageHov: Sport_Item_1_Hover,
    modal: 'sports-gallos',
  },
  {
    bgImage: Sport_Item_2,
    bgImageHov: Sport_Item_2_Hover,
    modal: 'sports-gatorade',
  },
  {
    bgImage: Sport_Item_3,
    bgImageHov: Sport_Item_3_Hover,
    modal: 'sports-puma-1',
  },
  {
    bgImage: Sport_Item_4,
    bgImageHov: Sport_Item_4_Hover,
    modal: 'sports-puma-2',
  },
  {
    bgImage: Sport_Item_5,
    bgImageHov: Sport_Item_5_Hover,
    modal: 'sports-puma-3',
  },
];

export const TIT_DRINKS = [
  {
    label: 'BEVERAGES',
  },
];

export const DRINKS_ITEMS = [
  {
    bgImage: Drinks_Item_1,
    bgImageHov: Drinks_Item_1_Hover,
    modal: 'drinks-torres10',
  },
  {
    bgImage: Drinks_Item_2,
    bgImageHov: Drinks_Item_2_Hover,
    modal: 'drinks-torres20',
  },
  {
    bgImage: Drinks_Item_3,
    bgImageHov: Drinks_Item_3_Hover,
    modal: 'drinks-real',
  },
  {
    bgImage: Drinks_Item_4,
    bgImageHov: Drinks_Item_4_Hover,
    modal: 'drinks-magna',
  },
  {
    bgImage: Drinks_Item_5,
    bgImageHov: Drinks_Item_5_Hover,
    modal: 'drinks-chateau',
  },
  {
    bgImage: Drinks_Item_6,
    bgImageHov: Drinks_Item_6_Hover,
    modal: 'drinks-codigo',
  },
  {
    bgImage: Drinks_Item_7,
    bgImageHov: Drinks_Item_7_Hover,
    modal: 'drinks-vasija',
  },
  {
    bgImage: Drinks_Item_8,
    bgImageHov: Drinks_Item_8_Hover,
    modal: 'drinks-vinas',
  },
  {
    bgImage: Drinks_Item_9,
    bgImageHov: Drinks_Item_9_Hover,
    modal: 'drinks-xa',
  },
];

export const TIT_CULTURAL = [
  {
    label: 'CULTURAL',
  },
];

export const CULTURAL_ITEMS = [
  {
    bgImage: Cultural_Item_1,
    bgImageHov: Cultural_Item_1_Hover,
    modal: 'cultural',
  },
];

export const TIT_CAMPANAS = [
  {
    label: 'CAMPAIGNS',
  },
];

export const CAMPANAS_ITEMS = [
  {
    bgImage: Campanas_Item_1,
    bgImageHov: Campanas_Item_1_Hover,
    modal: 'campanas-betvip',
  },
  {
    bgImage: Campanas_Item_2,
    bgImageHov: Campanas_Item_2_Hover,
    modal: 'campanas-betcris',
  },
  {
    bgImage: Campanas_Item_3,
    bgImageHov: Campanas_Item_3_Hover,
    modal: 'campanas-idealz',
  },
];
